exports.testNameRegex = (s) => {
  // note that only valid SSM parameter names are used for org names
  return /^[A-Za-z0-9.\-_]+$/.test(s);
};
